/* eslint-disable max-len */
import { ModelSnippetFn, Language } from '../types';

const pythonSDK: ModelSnippetFn = (props) => `
from clarifai.client.model import Model

# Your PAT (Personal Access Token) can be found in the Account's Security section
prompt = "What's the future of AI?"
# You can set the model using model URL or model ID.
model_url="https://clarifai.com/${props.userId}/${props.appId}/models/${props.modelId}"


# Model Predict
model_prediction = Model(url=model_url,pat="${props.pat}").predict_by_bytes(prompt.encode(), input_type="text")

print(model_prediction.outputs[0].data.text.raw)
`;

const python: ModelSnippetFn = (props) => `
######################################################################################################
# In this section, we set the user authentication, user and app ID, model details, and the URL of 
# the text we want as an input. Change these strings to run your own example.
######################################################################################################

# Your PAT (Personal Access Token) can be found in the Account's Security section
PAT = '${props.pat}'
# Specify the correct user_id/app_id pairings
# Since you're making inferences outside your app's scope
USER_ID = '${props.userId}'
APP_ID = '${props.appId}'
# Change these to whatever model and text URL you want to use
MODEL_ID = '${props.modelId}'
MODEL_VERSION_ID = '${props.modelVersionId}'
RAW_TEXT = 'I love your product very much'
# To use a hosted text file, assign the url variable
# TEXT_FILE_URL = '${props.inputUrl}'
# Or, to use a local text file, assign the url variable
# TEXT_FILE_LOCATION = 'YOUR_TEXT_FILE_LOCATION_HERE'

############################################################################
# YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
############################################################################

from clarifai_grpc.channel.clarifai_channel import ClarifaiChannel
from clarifai_grpc.grpc.api import resources_pb2, service_pb2, service_pb2_grpc
from clarifai_grpc.grpc.api.status import status_code_pb2

channel = ClarifaiChannel.get_grpc_channel()
stub = service_pb2_grpc.V2Stub(channel)

metadata = (('authorization', 'Key ' + PAT),)

userDataObject = resources_pb2.UserAppIDSet(user_id=USER_ID, app_id=APP_ID)

# To use a local text file, uncomment the following lines
# with open(TEXT_FILE_LOCATION, "rb") as f:
#    file_bytes = f.read()

post_model_outputs_response = stub.PostModelOutputs(
    service_pb2.PostModelOutputsRequest(
        user_app_id=userDataObject,  # The userDataObject is created in the overview and is required when using a PAT
        model_id=MODEL_ID,
        version_id=MODEL_VERSION_ID,  # This is optional. Defaults to the latest model version
        inputs=[
            resources_pb2.Input(
                data=resources_pb2.Data(
                    text=resources_pb2.Text(
                        raw=RAW_TEXT
                        # url=TEXT_FILE_URL
                        # raw=file_bytes
                    )
                )
            )
        ]
        ${
          props.deploymentId
            ? `, runner_selector=resources_pb2.RunnerSelector(
            deployment=resources_pb2.Deployment(
                id="${props.deploymentId}"

        )
        )`
            : ''
        }
        
    ),
    metadata=metadata
)
if post_model_outputs_response.status.code != status_code_pb2.SUCCESS:
    print(post_model_outputs_response.status)
    raise Exception(f"Post model outputs failed, status: {post_model_outputs_response.status.description}")

# Since we have one input, one output will exist here
output = post_model_outputs_response.outputs[0]

print("Completion:\\n")
print(output.data.text.raw)
`;

const javascript: ModelSnippetFn = (props) => `
////////////////////////////////////////////////////////////////////////////////////////////////////
// In this section, we set the user authentication, user and app ID, model details, and the URL
// of the text we want as an input. Change these strings to run your own example.
///////////////////////////////////////////////////////////////////////////////////////////////////

// Your PAT (Personal Access Token) can be found in the Account's Security section
const PAT = '${props.pat}';
// Specify the correct user_id/app_id pairings
// Since you're making inferences outside your app's scope
const USER_ID = '${props.userId}';    
const APP_ID = '${props.appId}';
// Change these to whatever model and text URL you want to use
const MODEL_ID = '${props.modelId}';
const MODEL_VERSION_ID = '${props.modelVersionId}'; 
const RAW_TEXT = 'I love your product very much';
// To use a hosted text file, assign the url variable
// const TEXT_FILE_URL = '${props.inputUrl}';
// Or, to use a local text file, assign the url variable
// const TEXT_FILE_BYTES = 'YOUR_TEXT_FILE_BYTES_HERE';

///////////////////////////////////////////////////////////////////////////////////
// YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
///////////////////////////////////////////////////////////////////////////////////

const raw = JSON.stringify({
    "user_app_id": {
        "user_id": USER_ID,
        "app_id": APP_ID
    },
    "inputs": [
        {
            "data": {
                "text": {
                    "raw": RAW_TEXT
                    // url: TEXT_URL, allow_duplicate_url: true 
                    // raw: fileBytes
                }
            }
        }
    ]
});

const requestOptions = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Authorization': 'Key ' + PAT
    },
    body: raw
};

// NOTE: MODEL_VERSION_ID is optional, you can also call prediction with the MODEL_ID only
// ${props.apiHost}/v2/models/{YOUR_MODEL_ID}/outputs
// this will default to the latest version_id

fetch("${props.apiHost}/v2/models/" + MODEL_ID + "/versions/" + MODEL_VERSION_ID + "/outputs", requestOptions)
    .then((response) => {
        return response.json();
    })
    .then((data) => {
        if(data.status.code != 10000) console.log(data.status);
        else console.log(data['outputs'][0]['data']['text']['raw']);
    }).catch(error => console.log('error', error));
`;

const java: ModelSnippetFn = (props) => `
package com.clarifai.example;

import com.clarifai.grpc.api.*;
import com.clarifai.channel.ClarifaiChannel;
import com.clarifai.credentials.ClarifaiCallCredentials;
import com.clarifai.grpc.api.status.StatusCode;

public class ClarifaiExample {

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    // In this section, we set the user authentication, user and app ID, model details, and the URL
    // of the text we want as an input. Change these strings to run your own example.
    //////////////////////////////////////////////////////////////////////////////////////////////////

    //Your PAT (Personal Access Token) can be found in the portal under Authentication
    static final String PAT = "${props.pat}";
    // Specify the correct user_id/app_id pairings
    // Since you're making inferences outside your app's scope
    static final String USER_ID = "${props.userId}";    
    static final String APP_ID = "${props.appId}";
    // Change these to whatever model and text URL you want to use
    static final String MODEL_ID = "${props.modelId}"; 
    static final String MODEL_VERSION_ID = "${props.modelVersionId}";   
    static final String RAW_TEXT = "I love your product very much";
    // To use a hosted text file, assign the url variable
    // static final String TEXT_URL = "${props.inputUrl}";
    // Or, to use a local text file, assign the url variable
    // static final String TEXT_FILE_LOCATION = "YOUR_TEXT_FILE_LOCATION_HERE";

    ///////////////////////////////////////////////////////////////////////////////////
    // YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
    ///////////////////////////////////////////////////////////////////////////////////	

    public static void main(String[] args) {

        V2Grpc.V2BlockingStub stub = V2Grpc.newBlockingStub(ClarifaiChannel.INSTANCE.getGrpcChannel())
            .withCallCredentials(new ClarifaiCallCredentials(PAT));

        MultiOutputResponse postModelOutputsResponse = stub.postModelOutputs(
            PostModelOutputsRequest.newBuilder()
            .setUserAppId(UserAppIDSet.newBuilder().setUserId(USER_ID).setAppId(APP_ID))
            .setModelId(MODEL_ID)
            .setVersionId(MODEL_VERSION_ID) // This is optional. Defaults to the latest model version
            .addInputs(
                Input.newBuilder().setData(
                    Data.newBuilder().setText(
                        Text.newBuilder()
                        .setRaw(RAW_TEXT)
                        // .setUrl(TEXT_URL)
                        // .setRawBytes(ByteString.copyFrom(Files.readAllBytes(
                        //     new File(TEXT_FILE_LOCATION).toPath()
                        // )))
                    )
                )
            )
            .build()
        );

        if (postModelOutputsResponse.getStatus().getCode() != StatusCode.SUCCESS) {
            throw new RuntimeException("Post model outputs failed, status: " + postModelOutputsResponse.getStatus());
        }

        // Since we have one input, one output will exist here
        Output output = postModelOutputsResponse.getOutputs(0);

        System.out.println("Predicted concepts:");
        System.out.println(output.getData().getText().getRaw());
        // for (Concept concept: output.getData().getConceptsList()) {
        //     System.out.printf("%s %.2f%n", concept.getName(), concept.getValue());
        // }

    }

}
`;

const nodejs: ModelSnippetFn = (props) => `
//index.js file

////////////////////////////////////////////////////////////////////////////////////////////////////
// In this section, we set the user authentication, user and app ID, model details, and the URL
// of the text we want as an input. Change these strings to run your own example.
/////////////////////////////////////////////////////////////////////////////////////////////////////

// Your PAT (Personal Access Token) can be found in the Account's Security section
const PAT = '${props.pat}';
// Specify the correct user_id/app_id pairings
// Since you're making inferences outside your app's scope
const USER_ID = '${props.userId}';
const APP_ID = '${props.appId}';
// Change these to whatever model and text URL you want to use
const MODEL_ID = '${props.modelId}';
const MODEL_VERSION_ID = '${props.modelVersionId}';
const RAW_TEXT = 'I love your product very much';
// To use a hosted text file, assign the url variable
// const TEXT_URL = '${props.inputUrl}';
// Or, to use a local text file, assign the url variable
// const TEXT_FILE_LOCATION = 'YOUR_TEXT_FILE_LOCATION_HERE';

///////////////////////////////////////////////////////////////////////////////////
// YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
///////////////////////////////////////////////////////////////////////////////////

const { ClarifaiStub, grpc } = require("clarifai-nodejs-grpc");

const stub = ClarifaiStub.grpc();

// This will be used by every Clarifai endpoint call
const metadata = new grpc.Metadata();
metadata.set("authorization", "Key " + PAT);

// To use a local text file, uncomment the following lines
// const fs = require("fs");
// const fileBytes = fs.readFileSync(TEXT_FILE_LOCATION);

stub.PostModelOutputs(
    {
        user_app_id: {
            "user_id": USER_ID,
            "app_id": APP_ID
        },
        model_id: MODEL_ID,
        version_id: MODEL_VERSION_ID, // This is optional. Defaults to the latest model version.
        inputs: [
            {
                "data": {
                    "text": {
                        "raw": RAW_TEXT
                        // url: TEXT_URL, allow_duplicate_url: true 
                        // raw: fileBytes
                    }
                }
            }
        ]
    },
    metadata,
    (err, response) => {
        if (err) {
            throw new Error(err);
        }

        if (response.status.code !== 10000) {
            console.log(response)
            throw new Error("Post model outputs failed, status: " + response.status.description);
        }

        // Since we have one input, one output will exist here.
        const output = response.outputs[0];

        console.log("Completion:\\n");
        console.log(output.data.text.raw);
    }

);
`;

const nodejs_SDK: ModelSnippetFn = (props) => `
import { Model } from "clarifai-nodejs";

// Your PAT (Personal Access Token) can be found in the Account's Security section
const prompt = "What’s the future of AI?";
// You can set the model using model URL or model ID.
const modelUrl = "https://clarifai.com/${props.userId}/${props.appId}/models/${props.modelId}";

// Model Predict
const model = new Model({
  url: modelUrl,
  authConfig: {
    pat: "${props.pat}",
  },
});


const modelPrediction = await model.predictByBytes({
  inputBytes: Buffer.from(prompt),
  inputType: "text",
});

console.log(modelPrediction?.[0]?.data?.text?.raw);
`;

const php: ModelSnippetFn = (props) => `
<?php
include_path='.:/opt/homebrew/Cellar/php/8.2.9/share/php/pear'
require __DIR__ . '/vendor/autoload.php';

////////////////////////////////////////////////////////////////////////////////////////////////////
// In this section, we set the user authentication, user and app ID, model details, and the URL
// of the text we want as an input. Change these strings to run your own example.
////////////////////////////////////////////////////////////////////////////////////////////////////

// Your PAT (Personal Access Token) can be found in the Account's Security section
$PAT = '${props.pat}';
// Specify the correct user_id/app_id pairings
// Since you're making inferences outside your app's scope
$USER_ID = '${props.userId}';
$APP_ID = '${props.appId}';
// Change these to whatever model and text URL you want to use
$MODEL_ID = '${props.modelId}';
$MODEL_VERSION_ID = '${props.modelVersionId}';
$RAW_TEXT = 'I love your product very much';
// To use a hosted text file, assign the url variable
// $TEXT_URL = '${props.inputUrl}';
// Or, to use a local text file, assign the url variable
// $TEXT_FILE_LOCATION = 'YOUR_TEXT_FILE_LOCATION_HERE';

///////////////////////////////////////////////////////////////////////////////////
// YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
///////////////////////////////////////////////////////////////////////////////////

use Clarifai\\ClarifaiClient;
use Clarifai\\Api\\Data;
use Clarifai\\Api\\Text;
use Clarifai\\Api\\Input;
use Clarifai\\Api\\PostModelOutputsRequest;
use Clarifai\\Api\\Status\\StatusCode;
use Clarifai\\Api\\UserAppIDSet;

$client = ClarifaiClient::grpc();

$metadata = ['Authorization' => ['Key ' . $PAT ]];

$userDataObject = new UserAppIDSet([
    'user_id' => $USER_ID, 
    'app_id' => $APP_ID 
]);

// To use a local text file, uncomment the following lines
// $textData = file_get_contents($TEXT_FILE_LOCATION);

// Let's make a RPC call to the Clarifai platform. It uses the opened gRPC client channel to communicate a
// request and then wait for the response
[$response, $status] = $client->PostModelOutputs(
    // The request object carries the request along with the request status and other metadata related to the request itself
    new PostModelOutputsRequest([
        'user_app_id' => $userDataObject,
        'model_id' => $MODEL_ID,  
        'version_id' => $MODEL_VERSION_ID, // This is optional. Defaults to the latest model version
        'inputs' => [
            new Input([ // The Input object wraps the Data object in order to meet the API specification                
                'data' => new Data([ // The Data object is constructed around the Text object. It offers a container that has additional text independent
                                    // metadata. In this particular use case, no other metadata is needed to be specified
                    'text' => new Text([ // In the Clarifai platform, a text is defined by a special Text object
                        'raw' => $RAW_TEXT 
                        // 'url' => $TEXT_URL 
                        // 'raw' => $textData 
                    ])
                ])
            ])
        ]        
    ]),
    $metadata
)->wait();

// A response is returned and the first thing we do is check the status of it
// A successful response will have a status code of 0; otherwise, there is some error
if ($status->code !== 0) {
    throw new Exception("Error: {$status->details}");
}

// In addition to the RPC response status, there is a Clarifai API status that reports if the operation was a success or failure 
// (not just that the communication was successful)
if ($response->getStatus()->getCode() != StatusCode::SUCCESS) {
    throw new Exception("Failure response: " . $response->getStatus()->getDescription() . " " .
        $response->getStatus()->getDetails());
}

// The output of a successful call can be used in many ways. In this example, we loop through all of the predicted concepts and print them out along with
// their numerical prediction value (confidence)
echo "Completion: </br>";
echo $response->getOutputs()[0]->getData()->getText()->getRaw()
// foreach ($response->getOutputs()[0]->getData()->getConcepts() as $concept) {
//     echo $concept->getName() . ": " . number_format($concept->getValue(), 2) . "</br>";
// }

?>
`;

const curl: ModelSnippetFn = (props) => `
# Model version ID is optional. It defaults to the latest model version, if omitted

curl -X POST "${props.apiHost}/v2/users/${props.userId}/apps/${props.appId}/models/${props.modelId}/versions/${props.modelVersionId}/outputs" \
  -H "Authorization: Key ${props.pat}" \
  -H "Content-Type: application/json" \
  -d '{
    "inputs": [
      {
        "data": {
          "text": {
            "raw": "I love your product very much"
          }
        }
      }
    ]
  }'
`;

export const llmSnippets = {
  [Language.Java]: java,
  [Language.cURL]: curl,
  [Language.Javascript]: javascript,
  [Language.Python]: python,
  [Language.PythonSDK]: pythonSDK,
  [Language.NodeJS]: nodejs,
  [Language.NodeJS_SDK]: nodejs_SDK,
  [Language.PHP]: php,
};
